module.exports = {"duration":"0.25s","longDuration":"0.5s"};